import { LINK_REL, LINK_TARGET, extractLinks } from '@garage/shared';
import { useMemo } from 'react';

/**
 * Corps d'un message (garage et portail, vague 4). Le texte est rendu comme du texte, jamais comme
 * du HTML ; seules les URL http(s) reconnues par `extractLinks` deviennent cliquables, ouvertes dans
 * un nouvel onglet sans référent ni lien avec la page (`LINK_REL`), avec le **nom de domaine réel
 * affiché en clair** à côté (anti-hameçonnage). Aucun aperçu, aucun appel vers l'URL.
 * Un `javascript:`, un `data:` ou une URL trop longue restent du texte.
 */
export function MessageBody({ text, className = '' }: { text: string; className?: string }) {
  const segments = useMemo(() => extractLinks(text), [text]);
  return (
    <p className={`whitespace-pre-line break-words ${className}`}>
      {segments.map((s, i) =>
        s.type === 'link' ? (
          <span key={i}>
            <a href={s.href} target={LINK_TARGET} rel={LINK_REL} className="break-all font-medium underline underline-offset-2">
              {s.text}
            </a>{' '}
            <span className="whitespace-nowrap text-xs font-medium opacity-80" data-testid="link-domain">
              ({s.domain})
            </span>
          </span>
        ) : (
          <span key={i}>{s.text}</span>
        ),
      )}
    </p>
  );
}
